import { render, staticRenderFns } from "./CPDueDiligenceSourceDetails.vue?vue&type=template&id=25b7cfb8&scoped=true&"
import script from "./CPDueDiligenceSourceDetails.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceSourceDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b7cfb8",
  null
  
)

export default component.exports